import { $host } from "./index";
import { TUserInfo } from "../types";

export class UserService {
  static getAllUsers() {
    return $host.get("user/all");
  }

  static getAllTeachersShort() {
    return $host.get<{ id: number; firstName: string; lastName: string }[]>(
      "user/teachers/short",
    );
  }
  static async deleteUser(email: string) {
    return await $host.post("user/delete", { email });
  }

  static async getUserInfo(id: number): Promise<TUserInfo> {
    const res = await $host.get("user/" + id);
    return res.data;
  }

  static async getUserWithTeacherInfo(id: number, teacherId: number) {
    return await $host.get("user/" + id + "/forteacher/" + teacherId);
  }

  static async updateUserWithTeacherInfo(
    id: number,
    teacherId: number,
    body: { lessonPrice: number; lessonPriceTeacher: number },
  ) {
    return await $host.patch("user/" + id + "/forteacher/" + teacherId, body);
  }

  static async updateUserInfo(body: TUserInfo) {
    return await $host.put("user/" + body.id, body);
  }

  static async updatePassword(id: number, body: { newPassword: string }) {
    return await $host.put("user/update-password/" + id, body);
  }

  static async saveUser(
    id: number,
    data: {
      firstName: string;
      lastName: string;
      email: string;
      nickname: string;
      sysName: string;
      grade: number;
    },
  ) {
    return await $host.put("user/" + id, data);
  }
}
